<template>
    <div @click="contextMenuVisible = false" >
        <!-- 右键菜单 -->
        <div
                v-show="contextMenuVisible"
                :style="{ position: 'absolute', top: menuPosition.y + 'px', left: menuPosition.x + 'px', zIndex: 2000 }"
                class="context-menu"
                @click.stop>
            <el-menu
                    default-active="2"
                    class="el-menu-vertical-demo"
                    @click.native.stop>
                <el-menu-item @click="removeAll">关闭所有标签</el-menu-item>
                <el-menu-item @click="closeLeft">关闭左边标签</el-menu-item>
                <el-menu-item @click="closeRight">关闭右边标签</el-menu-item>
                <el-menu-item @click="closeOther">关闭其他标签</el-menu-item>
            </el-menu>
        </div>

        <el-tabs v-model="editableTabsValue" @tab-click="handleClick" type="card" closable @tab-remove="removeTab" @contextmenu.prevent.native="handleRightClick($event)" class="custom-tabs">
            <el-tab-pane
                    v-for="(item, index) in editableTabs"
                    :key="item.name"
                    :label="item.desc"
                    :name="item.name"
            >
                <component :is="item.value" :status="item.status" :paramsInfo="paramsInfo"  ></component>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>


<script>
    import UserStat from "./app-user/user-stat";
    import ConsultStat from "./shop-certification/shop-certification-stat";
    import ProductOrderStat from "./product/order-stat";
    import SellerSettlementStat from "./product/seller-settlement-stat";
    import ProductReview from "./product/product-review";
    import VideoStat from "./video/video-stat";
    import OrderShipmentStat from "./orderShipment/order-shipment-stat";
    import CallbackStat from "./orderShipment/callback-stat";
    import CustomerServiceStat from "./customerService/customerService-stat";
    import LitigationStat from "./customerService/litigation-stat";

    import AppStat from "./customerService/app-stat";
    import DevStat from "./customerService/dev-stat";


    import DictInfo from "./auth/dictInfo";
    import AuthUser from "./auth/auth-user";
    import AuthRole from "./auth/auth-role";
    import OperationLog from "./auth/operation-log";
    export default {
        name: "home-page",
        components: {
            DictInfo,AuthUser,AuthRole,UserStat,ConsultStat,ProductOrderStat,ProductReview,CustomerServiceStat,AppStat,DevStat,
            VideoStat,OperationLog,SellerSettlementStat,OrderShipmentStat,CallbackStat,LitigationStat
        },
        props: ['menuPath'], // 由于我们在路由中设置了 props: true，type 将作为 prop 传入
        data () {
            return {
                editableTabsValue: '',
                contextMenuVisible: false,
                menuPosition: { x: 0, y: 0 },
                contextMenuStyle: {
                    position: 'fixed',
                    top: '0px',
                    left: '0px'
                },
                paramsInfo:{},
                editableTabs: [],
                tabIndex: 0,
                vehicleStatus:"Active",
                mainData:[
                    {"desc": "用户管理", "name": "user-stat", "value": "UserStat","status":0},
                    {"desc": "店铺认证", "name": "shop-certification-stat", "value": "ConsultStat","status":0},
                    {"desc": "产品订单", "name": "order-stat", "value": "ProductOrderStat","status":0},
                    {"desc": "结算管理", "name": "seller-settlement-stat", "value": "SellerSettlementStat","status":0},
                    {"desc": "产品评价", "name": "product-review", "value": "ProductReview","status":0},
                    {"desc": "视频管理", "name": "video-stat", "value": "VideoStat","status":0},
                    {"desc": "快递管理", "name": "order-shipment-stat", "value": "OrderShipmentStat","status":0},
                    {"desc": "回调管理", "name": "callback-stat", "value": "CallbackStat","status":0},

                    {"desc": "字典管理", "name": "dictInfo", "value": "DictInfo","status":0},
                    {"desc": "账号管理", "name": "auth-user", "value": "AuthUser","status":0},
                    {"desc": "角色管理", "name": "auth-role", "value": "AuthRole","status":0},
                    {"desc": "操作日志", "name": "operation-log", "value": "OperationLog","status":0},
                    {"desc": "客服管理", "name": "customerService-stat", "value": "CustomerServiceStat","status":0},
                    {"desc": "应用管理", "name": "app-stat", "value": "AppStat","status":0},
                    {"desc": "设备管理", "name": "dev-stat", "value": "DevStat","status":0},
                    {"desc": "诉讼管理", "name": "litigation-stat", "value": "LitigationStat","status":0},

                ],
                fallData:[
                    {"desc": "用户管理", "name": "user-stat", "value": "UserStat", "status": 0, "fullName": "/Home/main/app-user/user-stat"},
                    {"desc": "店铺认证", "name": "shop-certification-stat", "value": "ConsultStat", "status": 0, "fullName": "/Home/main/shop-certification/shop-certification-stat"},
                    {"desc": "产品订单", "name": "order-stat", "value": "ProductOrderStat", "status": 0, "fullName": "/Home/main/product/order-stat"},
                    {"desc": "结算管理", "name": "seller-settlement-stat", "value": "SellerSettlementStat", "status": 0, "fullName": "/Home/main/product/seller-settlement-stat"},
                    {"desc": "产品评价", "name": "product-review", "value": "ProductReview", "status": 0, "fullName": "/Home/main/product/product-review"},
                    {"desc": "视频管理", "name": "video-stat", "value": "VideoStat", "status": 0, "fullName": "/Home/main/video/video-stat"},
                    {"desc": "快递管理", "name": "order-shipment-stat", "value": "OrderShipmentStat", "status": 0, "fullName": "/Home/main/orderShipment/order-shipment-stat"},
                    {"desc": "回调管理", "name": "callback-stat", "value": "CallbackStat", "status": 0, "fullName": "/Home/main/orderShipment/callback-stat"},

                    {"desc": "字典管理", "name": "dictInfo", "value": "DictInfo", "status": 0, "fullName": "/Home/main/auth/dictInfo"},
                    {"desc": "账号管理", "name": "auth-user", "value": "AuthUser", "status": 0, "fullName": "/Home/main/auth/auth-user"},
                    {"desc": "角色管理", "name": "auth-role", "value": "AuthRole", "status": 0, "fullName": "/Home/main/auth/auth-role"},
                    {"desc": "操作日志", "name": "operation-log", "value": "OperationLog", "status": 0, "fullName": "/Home/main/auth/operation-log"},
                    {"desc": "客服管理", "name": "customerService-stat", "value": "CustomerServiceStat", "status": 0, "fullName": "/Home/main/CustomerServiceStat/customerService-stat"},
                    {"desc": "应用管理", "name": "app-stat", "value": "AppStat", "status": 0, "fullName": "/Home/main/CustomerServiceStat/app-stat"},
                    {"desc": "设备管理", "name": "dev-stat", "value": "DevStat", "status": 0, "fullName": "/Home/main/CustomerServiceStat/dev-stat"},
                    {"desc": "设备管理", "name": "litigation-stat", "value": "LitigationStat", "status": 0, "fullName": "/Home/main/CustomerServiceStat/litigation-stat"}
                 ],
                showContextMenu: false,
                currentTab: null,
            }
        },
        watch: {
            '$route' (to, from) {
                // 将参数传给组件
                this.paramsInfo = to.query;
                // 在这里你可以做更多的逻辑处理
                let newPath = to.path;
                // 判断是否存在
                this.dealTab(newPath);
                // 刷新页面
                this.flashPage();
            },

            contextMenuVisible() { //监听 右键关闭菜单 点击任何地方 菜单消失
                if (this.contextMenuVisible) {
                    document.body.addEventListener("click", this.closeMenu);
                } else {
                    document.body.removeEventListener("click", this.closeMenu);
                }
            }
        },
        created: function () {
            let pathname = window.location.pathname;  // 获取路径部分
            this.dealTab(pathname);
        },
        methods:{
            flashPage(){
                this.editableTabs.forEach(item=>{
                    if (item.name  == this.editableTabsValue) {
                        item.status = 1;
                    }else {
                        item.status =0;
                    }
                })
            },
            removeTab(targetName) {
                this.editableTabs = this.editableTabs.filter(tab => tab.name !== targetName);
                if (this.editableTabs.length && this.editableTabsValue === targetName) {
                    this.editableTabsValue = this.editableTabs[0].name;
                }
            },
            dealTab(newPath){
                // 选择所有类名为 'is-closable' 的元素
                var closableElements = document.querySelectorAll('.is-closable');

                // 遍历这些元素并删除 color 属性
                closableElements.forEach(function(element) {
                    element.style.color = ''; // 将 color 设置为空字符串，即移除直接设置的颜色
                });
                // 选择所有类名为 'el-tab-pane' 的元素
                var tabPanes = document.querySelectorAll('.el-tab-pane');

                // 遍历这些元素并设置 display 属性为 'none'
                // tabPanes.forEach(function(pane) {
                //     pane.style.display = 'none';
                // });

                // 使用 lastIndexOf 方法找到最后一个 '/' 的位置
                const lastIndex = newPath.lastIndexOf('/');
                // 使用 substring 方法从最后一个 '/' 之后的位置开始截取字符串
                const lastPart = newPath.substring(lastIndex + 1);
                let existPath  = false;
                // 存在显示当前页面
                for (let i = 0; i < this.editableTabs.length; i++) {
                    let item = this.editableTabs[i];
                    if(lastPart == item.name){
                        this.editableTabsValue = lastPart ;
                        existPath = true;
                        this.tabIndex = i;
                        break;
                    }
                }
                // 不存在直接添加
                if (!existPath) {
                    const lastPart = newPath.substring(lastIndex + 1);
                    for (let i = 0; i < this.mainData.length; i++) {
                        let item = this.mainData[i];
                        if(lastPart == item.name){

                            this.editableTabs.push(item);
                            this.tabIndex = this.editableTabs.length;
                            this.editableTabsValue = lastPart ;

                            break;
                        }
                    }
                }
            },
            handleClick(tab, event) {
                // 刷新页面 传参数
                this.flashPage();
                // 修改浏览器中的url
                window.history.pushState({}, '', tab.name);
                // 修改左边菜单栏 打开状态
                this.$store.dispatch('SetCurrentTab', tab.label);
            },
            handleRightClick(event) {
                this.contextMenuVisible = false;
                if (event.srcElement.id) {
                    // 右键点击的是tab
                    console.log(event);
                    this.currentTab = event.srcElement.innerText;
                    event.preventDefault();
                    this.contextMenuVisible = true;
                    this.menuPosition = { x: event.clientX, y: event.clientY };
                }
            },
            // 关闭所有标签
            removeAll() {
                this.editableTabs = [];
                this.currentTab = "";
                this.contextMenuVisible = false
            },
            // 关闭左边标签
            closeLeft() {
                let index = 0;

                let obj = {}; // 当前标签
                this.editableTabs.forEach((el, i) => {
                    if (this.currentTab == el.desc) {
                        index = i;
                        obj = el;
                    }
                });
                this.editableTabs = this.editableTabs.slice(index);
                this.contextMenuVisible = false
                this.editableTabsValue = obj.name;
            },

            // 关闭右边标签
            closeRight() {
                let index = 0;
                let obj = {}; // 当前标签
                this.editableTabs.forEach((el, i) => {
                    if (this.currentTab == el.desc) {
                        index = i;
                        obj = el;
                    }
                });
                this.editableTabs = this.editableTabs.slice(0, index + 1);
                this.contextMenuVisible = false;
                this.editableTabsValue = obj.name;

            },
            // 关闭其他标签
            closeOther() {
                let obj = {}; // 当前标签
                this.editableTabs.forEach((el) => {
                    if (this.currentTab == el.desc) {
                        obj = el;
                    }
                });
                this.editableTabs = [obj];
                this.editableTabsValue = obj.name;

                this.contextMenuVisible = false
            },

        }
    }
</script>
<style lang="less" scoped>
    .context-menu {
        border: 1px solid #d3dce6;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
    }

    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 150px;
    }

    .custom-tabs /deep/ .el-tabs__header {
        border-bottom: 1px solid #e4e7ed; /* 恢复默认的下边框 */
    }

    .custom-tabs /deep/ .el-tabs__item.is-active {
        border-bottom: 2px solid #409EFF; /* 恢复默认的活动标签下边框 */
        color: #409EFF;
    }
    .custom-tabs  /deep/ .el-tabs__item {
        color: #827f7f;
    }
    .custom-tabs  /deep/ .el-tabs__item:hover {
        border-bottom: 2px solid #409EFF; /* 恢复默认的活动标签下边框 */
        color: #409EFF;
    }

</style>
